const doc = [({"en":({"js":({"admin":({"layout":({"bottom_bar":({"pagination":({"showing_from_to_out_of_total":"Showing %{from}-%{to} of %{total_count}"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;